// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".report_view_content[data-v-f3e02d2e]{display:flex;align-items:center;color:var(--m-color-gray-700)}.report_view_content svg[data-v-f3e02d2e]{margin-right:2px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
